<button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon">close</mat-icon>
</button>

<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <div class="row mt-5">
            <div class="col-md-12">
                <div mat-dialog-title>
                    <div style="text-align: center;color: red;">Are you sure want to raise the refund ?</div>
                </div>
            </div>
        </div>
       
        <div class="mat-dialog-content">
            <div class="col-md-12">
                <mat-form-field appearance="outline" style="width: 100%;">
                    <mat-label>Refund Amount</mat-label>
                    <input matInput [(ngModel)]="data.refundData.RefundAmount" required readonly="true">
                    <mat-error>This feild is required</mat-error>
                </mat-form-field>
            </div>
            <alert></alert>
            <div class="buttonRow">
                <button mat-raised-button (click)="onNoClick()" class="create"
                [disabled]="isSubmitted">Yes</button>
                <button type="reset" mat-raised-button (click)="close()" class="cancel">No</button>
            </div>
        </div>
    </div>
</div>